module.exports = __webpack_public_path__ + "static/media/vinum_day.35e8b33d.jpeg";